export default __webpack_public_path__ + "static/media/Vector.e3d8e3c9.svg";